let ws: WebSocket | null = null;

export function setSocket(s: WebSocket | null) {
  ws = s;
}

export function sendLogoutAndClose(message: unknown) {
  if (!ws) return;
  ws.send(JSON.stringify(message));
  ws.close();
  ws = null;
}

export function isSocketOpen() {
  return !!ws && ws.readyState === WebSocket.OPEN;
}
